/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Loading_Translation_Please_WaitInputs */

const en_loading_translation_please_wait = /** @type {(inputs: Loading_Translation_Please_WaitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading translation... please wait...`)
};

const fr_loading_translation_please_wait = /** @type {(inputs: Loading_Translation_Please_WaitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chargement de la traduction... veuillez patienter...`)
};

const de_loading_translation_please_wait = /** @type {(inputs: Loading_Translation_Please_WaitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übersetzung wird geladen... Bitte warten...`)
};

const it_loading_translation_please_wait = /** @type {(inputs: Loading_Translation_Please_WaitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caricamento traduzione... attendere prego...`)
};

const ru_loading_translation_please_wait = /** @type {(inputs: Loading_Translation_Please_WaitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загрузка перевода... пожалуйста, подождите...`)
};

const es_loading_translation_please_wait = /** @type {(inputs: Loading_Translation_Please_WaitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargando traducción... por favor espere...`)
};

const zh_cn2_loading_translation_please_wait = /** @type {(inputs: Loading_Translation_Please_WaitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在加载翻译……请稍候……`)
};

const ja_loading_translation_please_wait = /** @type {(inputs: Loading_Translation_Please_WaitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`翻訳を読み込んでいます...お待ちください...`)
};

const hi_loading_translation_please_wait = /** @type {(inputs: Loading_Translation_Please_WaitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अनुवाद लोड हो रहा है... कृपया प्रतीक्षा करें...`)
};

const pt_pt2_loading_translation_please_wait = /** @type {(inputs: Loading_Translation_Please_WaitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregando tradução... aguarde...`)
};

/**
* | output |
* | --- |
* | "Loading translation... please wait..." |
*
* @param {Loading_Translation_Please_WaitInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const loading_translation_please_wait = /** @type {((inputs?: Loading_Translation_Please_WaitInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Loading_Translation_Please_WaitInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_loading_translation_please_wait(inputs)
	if (locale === "de") return de_loading_translation_please_wait(inputs)
	if (locale === "it") return it_loading_translation_please_wait(inputs)
	if (locale === "ru") return ru_loading_translation_please_wait(inputs)
	if (locale === "es") return es_loading_translation_please_wait(inputs)
	if (locale === "zh-CN") return zh_cn2_loading_translation_please_wait(inputs)
	if (locale === "ja") return ja_loading_translation_please_wait(inputs)
	if (locale === "hi") return hi_loading_translation_please_wait(inputs)
	if (locale === "pt-PT") return pt_pt2_loading_translation_please_wait(inputs)
	return en_loading_translation_please_wait(inputs)
});